export interface CurrencyOptions {
  locale?: string;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatCurrency(value: number, opts: CurrencyOptions = {}): string {
  const { locale = 'en-IN', currency = 'INR', minimumFractionDigits = 0, maximumFractionDigits = 0 } = opts;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
}

export function formatNumber(value: number, locale = 'en-IN'): string {
  return new Intl.NumberFormat(locale).format(value);
}

export function formatPercentage(value: number, decimals = 1): string {
  return `${value.toFixed(decimals)}%`;
}

export function formatDate(date: Date | string | number, format: 'short' | 'long' | 'iso' = 'short', locale = 'en-IN'): string {
  const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  switch (format) {
    case 'short':
      return d.toLocaleDateString(locale, { day: '2-digit', month: 'short', year: 'numeric' });
    case 'long':
      return d.toLocaleDateString(locale, { day: '2-digit', month: 'long', year: 'numeric' });
    case 'iso':
      return d.toISOString().split('T')[0];
    default:
      return d.toLocaleDateString(locale);
  }
}

export function formatTime(date: Date | string | number, locale = 'en-IN'): string {
  const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  return d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
}

export function formatCompactNumber(value: number): string {
  if (value >= 10000000) return `${(value / 10000000).toFixed(2)}Cr`;
  if (value >= 100000) return `${(value / 100000).toFixed(2)}L`;
  if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return value.toString();
}

export const CURRENCIES = [
  { code: 'INR', symbol: '₹', locale: 'en-IN', label: 'Indian Rupee' },
  { code: 'USD', symbol: '$', locale: 'en-US', label: 'US Dollar' },
  { code: 'EUR', symbol: '€', locale: 'de-DE', label: 'Euro' },
  { code: 'GBP', symbol: '£', locale: 'en-GB', label: 'British Pound' },
  { code: 'JPY', symbol: '¥', locale: 'ja-JP', label: 'Japanese Yen' },
  { code: 'AED', symbol: 'د.إ', locale: 'ar-AE', label: 'UAE Dirham' },
] as const;

export type CurrencyCode = (typeof CURRENCIES)[number]['code'];
